import { LayoutSetup, StepItemsList } from "@/components/setup/layout-setup";
import { useTranslation } from "@/hooks/useTranslation";
import { SetupBillingIntroductionPage } from "./team-creation-billing/0-introduction";
import { SetupBillingPaymentMethodPage } from "./team-creation-billing/1-payment-method";
import { SetupBillingFinishPage } from "./team-creation-billing/2-finish";

export const SetupTeamCreationBilling = () => {
  const { t } = useTranslation();

  const steps: StepItemsList = [
    {
      id: "introduction",
      label: t("setup.billing.steps.introduction"),
      element: <SetupBillingIntroductionPage />,
    },
    {
      id: "payment-method",
      label: t("setup.billing.steps.paymentMethod"),
      element: <SetupBillingPaymentMethodPage />,
    },
    {
      id: "finish",
      label: t("setup.billing.steps.finish"),
      element: <SetupBillingFinishPage />,
    },
  ];

  return <LayoutSetup steps={steps} />;
};
